"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDesktopSize = void 0;
const getDesktopSize = desktopSize => ({
  ...(desktopSize === 'small' ? {
    height: 20,
    width: 20,
    fontSize: '1.4rem'
  } : {}),
  ...(desktopSize === 'medium' ? {
    height: 36,
    width: 36,
    fontSize: '2.4rem'
  } : {}),
  ...(desktopSize === 'large' ? {
    height: 45,
    width: 45,
    fontSize: '2.7rem'
  } : {})
});
exports.getDesktopSize = getDesktopSize;
//# sourceMappingURL=utils.js.map